import React from 'react';
import PropTypes from "prop-types";
import {Col, Row} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {isAudioFile, isImageFile, isOfficeFile, isVideoFile} from "../document/utils/ExtensionUtils";
import DG_Editor_File from "./components//file/edit";
import {useFile} from "./hooks/useFile";

const maskProps = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999
}

const contentProps = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000
}

const PreviewV2 = ({visible, onCancel, fileId}) => {

    const [file] = useFile({fileId: visible ? fileId : null})

    return (
        visible && (
            <>
                <div style={maskProps} onClick={() => onCancel()}></div>
                <ActionMenu onCancel={onCancel}/>
                <div style={contentProps}>
                    <FilePreviewContent file={file}/>
                </div>
            </>
        )
    );
};

PreviewV2.propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    fileId: PropTypes.number,
    isEdit: PropTypes.bool
};

const ActionMenu = ({onCancel}) => {

    return (
        <Row className={"fixed top-0 left-0 w-full bg-[rgba(0,0,0,.1)]"} justify={"space-between"}
             style={{zIndex: 1000}}>
            <Col>
            </Col>
            <Col onClick={onCancel} className={"cursor-pointer"}>
                <CloseOutlined className={"text-xl p-4 text-white"}/>
            </Col>
        </Row>
    );
};

const FilePreviewContent = ({file}) => {
    return (
        <>
            {isOfficeFile(file?.fileType) && <DG_Editor_File
                style={{width: "90vw", height: "90vh", pointerEvents: "auto", marginTop: "5vh"}}
                fileId={file.id}
                action={"view"}
            />}

            {isImageFile(file?.fileType) && (
                <img
                    style={{maxWidth: "90vw", maxHeight: "90vh", pointerEvents: "auto", marginTop: "5vh"}}
                    src={file?.url}
                    alt={""}
                />
            )}

            <div>
                {isVideoFile(file?.fileType) && (
                    <video style={{maxWidth: "90vw", maxHeight: "100vh", pointerEvents: "auto"}} controls>
                        <source src={file.url}/>
                    </video>
                )}

                {isAudioFile(file?.fileType) && (
                    <audio controls style={{pointerEvents: "auto"}}>
                        <source src={file?.url}/>
                        Your browser does not support the audio element.
                    </audio>
                )}

            </div>

        </>
    );
};

export default PreviewV2;
